/* @flow */
import { ActionTypes } from 'constants/DeviceConstants';
import { ActionTypes as UserActionTypes } from 'user/UserConstants';
import API from 'lib/RemindAPI';
import Device from 'entities/Device';
import User from 'entities/User';
import { dispatcher } from 'lib/Dispatcher';

const DeviceActions = {
  loadDevices(ids?: number[]) {
    const all = ids === undefined;
    const params = all ? undefined : { ids };

    return API.request('/devices/batch', 'POST', params).then(result => {
      const devices = result.devices.map(device => Device.fromJSON(device));

      dispatcher.dispatch({
        type: ActionTypes.LOAD_DEVICES,
        devices,
        all,
      });

      return devices;
    });
  },

  /* Enables a user's main email device.
   * It kinda like DeviceActions.enable(emailDevice)
   * but this will create the email device if none exist.
   */
  enableEmailDevice(): Promise<Device> {
    return Device.enableEmailDevice().then(device => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_DEVICE,
        device,
      });

      return device;
    });
  },

  newEmailDevice(uid: string): Promise<Device> {
    return Device.createEmailDevice(uid).then(device => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_DEVICE,
        device,
      });

      return device;
    });
  },

  deleteEmailDevice(device: Device): Promise<Device> {
    return device.delete().then(() => {
      dispatcher.dispatch({
        type: ActionTypes.DELETE_DEVICE,
        device,
      });

      return device;
    });
  },

  /*
   * Begin a outbound sms verification process, the resolved
   * promise will return a token. You need to pass this token
   * and the code received by sms to the createOutboundDevice function.
   */
  outboundVerify(endpoint: string) {
    return Device.outboundVerify(endpoint);
  },

  /* @param token - the token returned by outboundVerify.
   * @param code - the 4 digit code received by SMS.
   */
  createOutboundDevice(token: string, code: string) {
    return Device.createOutboundDevice(token, code).then((response) => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_DEVICE,
        device: response.device,
      });

      return response;
    });
  },

  localDeleteAll() {
    dispatcher.dispatch({
      type: ActionTypes.DELETE_ALL_DEVICES,
    });

    return new Promise(resolve => resolve());
  },

  /* local delete to remove the device from the store
   * this is because the API destroy the sms device by itself
   * once we add a new sms device.
   */
  localDelete(device: Device) {
    dispatcher.dispatch({
      type: ActionTypes.DELETE_DEVICE,
      device,
    });

    return new Promise(resolve => resolve(device));
  },

  enable(deviceToEnable: Device) {
    return deviceToEnable.enable().then((device) => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_DEVICE,
        device,
      });
    });
  },

  disable(deviceToDisable: Device) {
    return deviceToDisable.disable().then((device) => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_DEVICE,
        device,
      });
    });
  },

  resendConfirmationEmail(uid: string) {
    return API.request('/devices/email/resend', 'POST', { uid });
  },

  createEmailMergeRequest(endpoint: string) {
    return Device.createEmailMergeRequest(endpoint);
  },

  emailMergeRequest(code: string, oldUserEmail: string) {
    return Device.emailMergeRequest(code, oldUserEmail)
    .then((user) => {
      dispatcher.dispatch({
        type: UserActionTypes.USER_UPDATED,
        user: User.fromJSON(user),
      });
    });
  },
};

export default DeviceActions;



// WEBPACK FOOTER //
// ./src/actions/DeviceActions.js